import playInUploadModalStyles from '../PlayInUploadModal/playInUploadModal.module.scss'
import Icon, { IconType } from '@bt-react/components/Icon'
import React from 'react'

const EmptyPlayInList = () => <div
  className={playInUploadModalStyles[`empty-list`]}
>
  <div className={playInUploadModalStyles[`empty-list-content`]}>
    <Icon
      name={IconType.iconName.playOutline}
      colour={IconType.colour.secondary}
      className={playInUploadModalStyles[`large-icon`]}
    />
    <div>
      <div
        className={playInUploadModalStyles[`no-content-text`]}
      >
      </div>
      No videos added
    </div>
  </div>
</div>

export default EmptyPlayInList
